import React, { Component, useEffect, useContext } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { AccountContext, SampleAuthContext, MealAuthContext } from 'context'
import { request, track } from 'meinian-package/src/utils'
import util from 'meinian-package/src/utils/util'

import InspirationFreezeModal from 'view/components/inspirationFreezeModal'
import NewStudentsModal from 'view/components/newStudentsModal'
import Meinian from 'meinian-package/src/meinian'
import isIPad from 'meinian-package/src/common/isIPad'
import Router from './router'
import WorkbenchSkeleton from './view/home/workbench/skeleton'
import Socket from './component/socket'
import hasLogin from './common/hasLogin'

const fetchAccountInfo = async () => {
  const res = await Promise.allSettled([
    request.get('/backend-api/app-dataline/data-line/team/team-sharing-setting'),
    request.get('/backend-api/app-dataline/data-line/user/user-perm'),
    request.get('/v1-5-1/hot/hot-taobao-category'),
    request.get('/backend-api/sso-api/user/get-info'),
  ])

  const [
    { value: { teamSharingType } },
    { value: authInfo = {} },
    { value: categories = [] },
    { value: userInfo = {} },
  ] = res

  const accountInfo = {
    teamSharingType,
    ...userInfo,
    userAuthCodeList: authInfo.permCodeList || [],
    teamAuthCodeList: authInfo.teamPermCodeList || [],
  }
  if (categories) {
    accountInfo.rootCategoryIds = []
    accountInfo.rootCategories = categories.filter(m => m.authAble && m.aiData).map((m) => {
      accountInfo.rootCategoryIds.push(m.first.id)
      return m.first.name
    })
    accountInfo.categoryId = categories.filter(m => m.authAble)?.[0]?.second?.[0]?.id
    accountInfo.rootCategoryId = accountInfo.rootCategoryIds[0]
    if (accountInfo && accountInfo.phone) {
      accountInfo.userPhone = Number(accountInfo.phone)
    }
  }
  accountInfo.industryRootCategoryId = categories.filter(m => m.authAble && m.industryAnalysis)[0]
  accountInfo.categories = categories
  localStorage.userAuthCodeList = JSON.stringify(accountInfo.userAuthCodeList)
  localStorage.teamAuthCodeList = JSON.stringify(accountInfo.teamAuthCodeList)
  sessionStorage.setItem('zkRootCategoryIds', JSON.stringify(accountInfo.rootCategoryIds))

  // 登记埋点
  track.login(accountInfo.userId)
  track.registerInfo({
    dyPermit: accountInfo?.userAuthCodeList?.indexOf('dl_tiktok_data') !== -1 ? '已开通抖音' : '未开通抖音',
    zkPermit: accountInfo?.userAuthCodeList?.indexOf('dl_ins') !== -1 ? '已开通知款' : '未开通知款'
  })
  return accountInfo
}

const fetchSampleAuth = async () => {
  const result = await request.get('/zhikuan/mn/sample/auth/get-user-folder-auth')
  localStorage.sampleAuthCodeList = JSON.stringify(result)
  return result
}

const fetchTeamInfo = async () => {
  const authInfo = await request.get('/backend-api/sso-api/team/auth-info')
  const userInfo = await request.get('/backend-api/app-dataline/data-line/user/user-info')
  const baseInfo = await request.get('/backend-api/sso-api/team/base-info')
  const personalInfo = await request.get('/backend-api/sso-api/user/get-info')
  const teamInfo = await request.get('/backend-api/app-dataline/data-line/team/get-team-info')
  track.registerInfo({
    teamId: teamInfo?.teamId || '',
    roleLevel: teamInfo?.roleId || -1,
    province: teamInfo?.province || '',
    city: teamInfo?.city || '',
    district: teamInfo?.district || '',
    teamGenre: teamInfo?.teamGenre || -1,
    teamType: teamInfo?.teamType || -1,
    industries: teamInfo?.industries || '',
    memberType: teamInfo?.department?.title || '',
    teamName: teamInfo?.teamName || '',
  })
  return { ...authInfo, ...teamInfo, ...userInfo, ...baseInfo, ...personalInfo }
}

const fetchMealInfo = async () => {
  const result = await request.get('/zhikuan/ins/inspiration/auth/get-meal-auth')
  localStorage.setItem('mealAuthCodeList', JSON.stringify(result))
  return result
}

export default class App extends Component {
  state = {
    account: {},
    sampleAuth: null,
    mealAuth: null,
    loading: true
  }

  async componentDidMount() {
    // 后端埋点需要
    if (!window.sessionHistory || window.sessionHistory.length === 0) {
      window.sessionHistory = [
        window.location.pathname.substring(1).replace('/', '_') + window.location.hash.replace('#', '_'),
        window.location.pathname.substring(1).replace('/', '_') + window.location.hash.replace('#', '_')
      ]
    }
    // 全局滚动到顶部方法
    window.scrollToTop = () => {
      const scroller = document.getElementsByClassName('ant-layout-content').length ? document.getElementsByClassName('ant-layout-content')[0] : ''
      if (!scroller) {
        return
      }
      scroller.scrollTop = 0
    }

    // 监听路由变化
    const sessionHistory = [sessionStorage.getItem('oldUrl') || localStorage.getItem('oldUrl') || '/shopwatch_base']
    const MutationObserver = window.MutationObserver || window.WebKitMutationObserver
    const observer = new MutationObserver((() => {
      sessionStorage.pathname = window.location.pathname.substring(1).replace('/', '_') + window.location.hash.replace('#', '_')
      localStorage.setItem('oldUrl', sessionStorage.pathname)
      sessionStorage.setItem('oldUrl', sessionStorage.pathname)
      sessionStorage.setItem('count', 0)
      sessionHistory.push(sessionStorage.pathname)
      // 路由堆栈只保存两个
      if (sessionHistory.length > 2) sessionHistory.shift()
      if (sessionHistory[0] === sessionHistory[1]) {
        sessionStorage.setItem('count', Number(sessionStorage.count) + 1)
      }
      window.sessionHistory = sessionHistory
    }))

    if (document.getElementById('title')) {
      observer.observe(document.getElementById('title'), { characterData: false, childList: true, attributes: false })
    }
    if (hasLogin()) {
      try {
        const mealAuth = await fetchMealInfo()
        const userInfo = await fetchAccountInfo()
        const teamInfo = await fetchTeamInfo()
        const sampleAuth = await fetchSampleAuth()
        sessionStorage.setItem('teamInfo', JSON.stringify(teamInfo))
        sessionStorage.setItem('account', JSON.stringify(userInfo))
        this.setState(pre => ({ account: { ...pre.account, userInfo, teamInfo, }, sampleAuth, mealAuth, loading: false }))
      } catch (err) {
        sessionStorage.setItem('teamInfo', JSON.stringify({}))
        sessionStorage.setItem('account', JSON.stringify({}))
        this.setState({ loading: false })
      }
    } else {
      sessionStorage.setItem('teamInfo', JSON.stringify({}))
      sessionStorage.setItem('account', JSON.stringify({}))
      this.setState({ loading: false })
    }
  }

  render() {
    const { loading, account, sampleAuth, mealAuth } = this.state
    return loading ? <WorkbenchSkeleton />
      : <AccountContext.Provider value={account}>
        <SampleAuthContext.Provider value={sampleAuth}>
          <MealAuthContext.Provider value={mealAuth}>
            <BrowserRouter basename="/meinian">
              {hasLogin() && <>
                <InspirationFreezeModal />
                <NewStudentsModal />
              </>}
              <Router />
              <SocketWrap />
            </BrowserRouter>
          </MealAuthContext.Provider>
        </SampleAuthContext.Provider>
      </AccountContext.Provider>
  }
}

const SocketWrap = () => {
  const account = useContext(AccountContext)
  useEffect(() => {
    Socket.init()
    return () => {
      Socket.unmount()
    }
  }, [])

  useEffect(() => {
    document.getElementById('root').setAttribute('height', document.body.clientHeight.toString())
    document.body.style.setProperty('--m-ipad-vh', `${isIPad ? `${document.body.clientHeight.toString()}px` : '100vh'}`)
  }, [])

  useEffect(() => {
    util.track('mn-page')
    if (hasLogin()) {
      Meinian.init({
        userInfo: account.userInfo,
        teamInfo: account.teamInfo
      })
    }
  }, [])

  return null
}
